/**
 * Vuex store module for managing notifications
 */
export const notifications = {
  namespaced: true,
  
  state: {
    items: []
  },
  
  mutations: {
    /**
     * Add a notification to the store
     * 
     * @param {Object} state - The state object
     * @param {Object} notification - The notification to add
     */
    ADD_NOTIFICATION(state, notification) {
      // Check if notification with same ID already exists
      const existingIndex = state.items.findIndex(item => item.id === notification.id);
      if (existingIndex !== -1) {
        // Update existing notification
        state.items[existingIndex] = { ...state.items[existingIndex], ...notification };
      } else {
        // Add new notification
        state.items.push(notification);
      }
    },
    
    /**
     * Remove a notification from the store
     * 
     * @param {Object} state - The state object
     * @param {string} id - The ID of the notification to remove
     */
    REMOVE_NOTIFICATION(state, id) {
      state.items = state.items.filter(notification => notification.id !== id);
    },
    
    /**
     * Clear all notifications from the store
     * 
     * @param {Object} state - The state object
     */
    CLEAR_ALL(state) {
      state.items = [];
    }
  },
  
  actions: {
    /**
     * Add a notification
     * 
     * @param {Object} context - The Vuex context
     * @param {Function} context.commit - The commit function
     * @param {Object} notification - The notification to add
     */
    add({ commit }, notification) {
      commit('ADD_NOTIFICATION', notification);
    },
    
    /**
     * Remove a notification
     * 
     * @param {Object} context - The Vuex context
     * @param {Function} context.commit - The commit function
     * @param {string} id - The ID of the notification to remove
     */
    remove({ commit }, id) {
      commit('REMOVE_NOTIFICATION', id);
    },
    
    /**
     * Clear all notifications
     * 
     * @param {Object} context - The Vuex context
     * @param {Function} context.commit - The commit function
     */
    clearAll({ commit }) {
      commit('CLEAR_ALL');
    }
  },
  
  getters: {
    /**
     * Get all notifications
     * 
     * @param {Object} state - The state object
     * @returns {Array} The array of notifications
     */
    all: state => state.items,
    
    /**
     * Get the number of active notifications
     * 
     * @param {Object} state - The state object
     * @returns {number} The number of notifications
     */
    count: state => state.items.length,
    
    /**
     * Get notifications of a specific type
     * 
     * @param {Object} state - The state object
     * @returns {Function} A function that filters notifications by type
     */
    byType: state => type => {
      return state.items.filter(notification => notification.type === type);
    }
  }
};

export default notifications;